import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.page,
  flexGrow: 1,
  padding: "30px 0",
  minHeight: "calc(100vh - 200px)",

  [theme.down("sm")]: {
    padding: "15px 0",
  },
}));

export const Block = styled("div")(({ theme }) => ({
  ...theme.mixins.flexJustifyBetween,
  alignItems: "flex-start",
  gap: 20,
  padding: "10px 0",

  [theme.down("lg")]: {
    flexDirection: "column",
    gap: 15,
  },

  [theme.down("sm")]: {
    padding: "5px 0",
  },
}));

export const RoutesDataAndFormBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  flexGrow: 1,
  gap: 20,

  [theme.down("lg")]: {
    order: 1,
    width: "100%",
  },

  [theme.down("sm")]: {
    gap: 15,
  },
}));
